// This file was generated using `pay js:run gql-v1 --type=fragment --name=StripeAccountUnificationAccountControllerDashboard --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

import {gql} from '@sail/data';

import type {GraphQlDocument} from '@sail/data';
import type {
  Exact,
  OpenapiAccountUnificationAccountControllerDashboardTypeEnum,
} from '@stripe-internal/data-v1/schema/types';

import type {V1PermissionToken} from '@stripe-internal/data-v1/types';

const doc = gql`
  fragment StripeAccountUnificationAccountControllerDashboardFragment on OpenapiAccountUnificationAccountControllerDashboard {
    type
  }
`;

export const stripeAccountUnificationAccountControllerDashboardFragment: StripeAccountUnificationAccountControllerDashboardFragmentDocument =
  doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type StripeAccountUnificationAccountControllerDashboardFragmentData = {
  readonly __typename: 'OpenapiAccountUnificationAccountControllerDashboard';
  readonly type: OpenapiAccountUnificationAccountControllerDashboardTypeEnum;
};

export type StripeAccountUnificationAccountControllerDashboardFragmentVariables =
  Exact<{[key: string]: never}>;

const stripeAccountUnificationAccountControllerDashboardFragmentPermissions =
  {} as const;

doc.permissions =
  stripeAccountUnificationAccountControllerDashboardFragmentPermissions;

export type StripeAccountUnificationAccountControllerDashboardFragmentPermissions =
  V1PermissionToken<
    typeof stripeAccountUnificationAccountControllerDashboardFragmentPermissions
  >;

export type StripeAccountUnificationAccountControllerDashboardFragmentDocument =
  GraphQlDocument<
    StripeAccountUnificationAccountControllerDashboardFragmentData,
    StripeAccountUnificationAccountControllerDashboardFragmentVariables,
    StripeAccountUnificationAccountControllerDashboardFragmentPermissions
  >;
